<template>
    <div>
        <BasicDialog @close="closeDialog">
            <v-row>


                <v-col cols="12" class="d-flex flex-row justify-center align-center">
                    <logo-background></logo-background>
                    <div style="position: absolute;" class="d-flex flex-row justify-center align-ceenter">
                        <img :src="AppConfigs.staticImages.INVITEFRIENDS" alt="Invite Friends" style="width: 80%; height: auto;">
                    </div>
                </v-col>



                <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
                    Invite Your Friends
                </v-col>



                <v-col cols="12" class="text-center">
                    When you share this with your friend and they join, you'll earn {{ coinsForInvitingFriends }} coins
                    for each friend you invite, plus an additional 5% of all the coins they withdhraw from the platform.
                </v-col>



                <v-col cols="12" class="d-flex flex-row justify-center">
                    <v-btn class="button--primary" @click="copyReferralCode">
                        <v-icon><copy-code></copy-code></v-icon>
                        <span class="text-body-2 ml-2">{{ referralCode }}</span>
                    </v-btn>
                </v-col>


            </v-row>

        </BasicDialog>
    </div>
</template>



<script>

import { AppConfigs } from "@/app.configs";
import CopyCode from '@/icons/CopyWhite.vue';
import { useUserStore } from "@/store/UserStore";
import { useSnackbar } from '@/composables/useSnackbar';
import { CopyToClipboard } from "@/utils/utils.ts";
import LogoBackground from "@/icons/LogoBackground.vue";
import { UserActivityStore } from '@/store/UserActivityStore';
import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import { defineComponent, inject, provide, computed, ref } from 'vue';






export default defineComponent({
    name: 'InviteFriendsDialog',
    components: {
        CopyCode,
        BasicDialog,
        LogoBackground,
    },


    setup(props, { emit }) {

        let openDialog = ref(false)
        openDialog = inject('inHouseTaskOpenDialog');
        provide('openDialog', openDialog);

        const userStore = useUserStore();
        const referralCode = computed(() => { return userStore.user.referral_code });
        const { showSnackbar } = useSnackbar();

        const closeDialog = () => { emit('close'); }

        const closeClicked = () => {
            openDialog.value = false;
        }

        const copyReferralCode = () => {
            try {
                CopyToClipboard(referralCode.value);
                showSnackbar({
                    message: 'Copied to clipboard!',
                    color: 'info'
                });
            } catch (err) {
                showSnackbar({
                    message: 'Error copying to clipboard',
                    color: 'error'
                });
            }

            setTimeout(() => {
                closeClicked();
            }, 1000);
        };


        const inHouseTaskStore = UserActivityStore();
        const coinsForInvitingFriends = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
        const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);


        return {
            AppConfigs,
            isAvailable,
            closeDialog,
            referralCode,
            copyReferralCode,
            coinsForInvitingFriends,
        }
    }
})
</script>
